module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "inner"
  }, [(_vm.variant === 'quote') ? [_c('blockquote', {
    domProps: {
      "innerHTML": _vm._s(_vm.texxt)
    }
  })] : [_c('div', {
    staticClass: "textbody",
    domProps: {
      "innerHTML": _vm._s(_vm.texxt)
    }
  })]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08bddbe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__Story__Text.vue
// module id = 373
// module chunks = 1